// Unknown or broken block types degrade gracefully instead of crashing the page (spec section 31).
export default function UnsupportedBlock({ block, failed }) {
  return (
    <div className="content-unsupported" role="note">
      {failed
        ? `This content block ("${block?.type}") could not be displayed.`
        : `Unsupported content block: "${block?.type}". This content block is not supported by the current website version.`}
    </div>
  );
}
